import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.bn{align-items:flex-start;}.ssr-plugin'
import '.h{gap:1.5rem;}.ssr-plugin'
import '.db{background:var(--palette-white);}.ssr-plugin'
import '.a3{flex-direction:row;}.ssr-plugin'
import '.dp{justify-content:flex-start;}.ssr-plugin'
import '.j1{gap:2.5rem;}.ssr-plugin'
import '.dm{flex-wrap:wrap;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.a6{gap:0.5rem;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'

export interface NutshellItem {
  total: string | number
  subtitle: string
}

export interface NutshellProps {
  heading: string
  items: NutshellItem[]
  style?: Style
}

export const Nutshell = ({ heading, items, style }: NutshellProps) => {
  return (
    <styled.div className="d e bn h db"
      data-testid="nutshell"
      style={{
        ...style,
      }}
    >
      {/* Heading */}
      <Title.H4
        style={{
          color: 'var(--brand-secondary)',
          textAlign: 'center',
          margin: 0,
        }}
      >
        {heading}
      </Title.H4>

      {/* Data Points Container */}
      <div className="d a3 dp bn j1 dm"
      >
        {items.map((item, index) => (
          <div className="d e f a6"
            key={index}
          >
            {/* Total Number */}
            <Title.H1
              style={{
                fontSize: '4rem',
                fontWeight: '700',
                lineHeight: '100%',
                margin: 0,
                color: 'var(--brand-secondary)',
                fontFamily: 'FunnelDisplay',
              }}
            >
              {item.total}
            </Title.H1>

            {/* Subtitle */}
            <Text.Medium
              style={{
                color: 'var(--brand-secondary)',
                opacity: 0.6,
                margin: 0,
                textAlign: 'center',
              }}
            >
              {item.subtitle}
            </Text.Medium>
          </div>
        ))}
      </div>
    </styled.div>
  )
}
